import React, { useState, useCallback, useRef, useEffect } from 'react';
import { connect, useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { convertDateFormat, getformatedDate } from "../../shared/core/datehelper";
import { View, Text, ActivityIndicator, FlatList } from "react-native-web";
import LetterHandler from '../components/LetterHandler';
import { GetDayName, GetAppointmentDate, GetMonthName, ReturnTypeIcon, GetYear, FormateUTCTime } from '../../shared/core/datehelper';
import getUserId from "../../shared/core/GetToken";
import { fetchProfileFromApi } from '../../shared/actions/ProfileActions';
import { Button, DatePicker, Modal, Spin } from "antd";

import { fetchServiceTemplateApi, searchServiceTemplateFromApi } from '../../shared/actions/ServiceTemplateActions';
import ServiceHandler from '../components/ServiceHandler';
import getUserInfo from '../../shared/core/GetTokenized';
import { appServices } from '../../shared/redux/actions/appServices';
import Iframe from '../components/Iframe';
const { RangePicker } = DatePicker;

const ServiceTemplate = props => {
    // const { Profile, isFetching } = props.Profile;
    const componentRef = useRef();
    const [username, setusername] = useState('');
    const [isLoadingPdf, setIsLoadingPdf] = useState(false);
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const [screeningId, setscreeningId] = useState("")
    const {GetScreeningTemplateHTML , isGetScreeningTemplateHTML} =useSelector((state)=> state.GetScreeningTemplateHTML)
    const dispatch= useDispatch()
    const [isloaded, setIsload] = React.useState(false);
    // const { ServiceTemplate, isServiceTemplate } = props.ServiceTemplate
    const { ServiceTemplate, isServiceTemplate } = useSelector((state)=>state.PatientScreeningList)
    const [visible, setVisible] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [htmlLetter, setHtmlLetter] = useState('');
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
      const PatienInformation = JSON.parse(information);
    
      const serviceTObj={
        PatientID: Profile && Profile[0].resource.id,
        StatusID:1,
        PageSize: pageSize,
        PageNumber: pageNumber,
      }
    
    React.useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://indici-pre-production.web.app/assets/js/template.js";
        document.body.appendChild(script)
        setusername(PatienInformation.username)
        // d.div.appendChild(script);
    }, [])

    // React.useEffect(() => {
    //     dispatch(appServices.PatientProfile({
    //         PatientID : Profile[0].resource.id
    //     }))
    //     // props.getProfile();
    // }, [])

    useEffect(() => {
       if(Profile) dispatch(appServices.PatientScreeningList(serviceTObj))
        // props.getServiceTemplate(pageSize, pageNumber);
    }, [Profile])

    useEffect(() => {
        if(GetScreeningTemplateHTML){
          var decodedHTML = atob(GetScreeningTemplateHTML[0].resource.extension[0].valueString)
          console.log(decodedHTML , "decodedHTML")
          setHtmlLetter(decodedHTML)
          setVisible(true)

        //   setHtmlLetter((state) => {
        //       return state;
        //   });
          //document.getElementById("showPDFLetters").innerHTML = decodedHTML
  
          setIsLoadingPdf(false); 
        }else{
          setVisible(false)
        }
      }, [GetScreeningTemplateHTML])

      function handlePrint() {


        var bodyHtml = /<body.*?>([\s\S]*)<\/body>/.exec(htmlLetter)[1];
        console.log("hello test " + bodyHtml)
        //alert(bodyHtml);

        var a = window?.open();
        a.document.write('<html>');

        a.document.write('<head>');
        a.document.write('<link href="https://devnhl.indici.ie/Content/style.css" rel="stylesheet"> <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet" type="text/css">  <link href="https://devnhl.indici.ie/Content/CustomCss/MailMerge/MailMergePrint.css" rel="stylesheet"> <script src="https://devnhl.indici.ie/Scripts/jquery-2.1.4.min.js"></script>');
        a.document.write('<style>.watermark{height:100%;display:block;position:relative}.watermark::after{content:"";background:url(https://banner2.cleanpng.com/20180512/oxe/kisspng-paper-rubber-stamp-stock-photography-royalty-free-5af72d03738f71.0212011215261483554733.jpg) no-repeat;opacity:0.2;top:0;left:0;bottom:0;right:0;position:absolute;z-index:-1} @media print{*{-webkit-print-color-adjust:exact}} *{-webkit-print-color-adjust: exact !important; color-adjust: exact !important;}@media screen{div.divFooter{display: none;}}@media print{div.divFooter{position: fixed; bottom: 0;}}</style>')
        a.document.write('</head>');

        a.document.write('<body>');

        a.document.write('<div className="watermark"><div className="col-md-12">' + bodyHtml + '</div>')
        a.document.write('<div className="divFooter"><p id="hello"></p></div></div>');
        a.document.write('<div className="divFooter">' + username + '</div></div>');


        //a.document.write(htmlLetter);


        a.document.write('<script>var currentdate=new Date();var datetime="Printed: " + currentdate.getDate() + "/" + (currentdate.getMonth()+1) + "/" + currentdate.getFullYear() + " @ " + currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();document.getElementById("hello").innerHTML=datetime;</script>')
        a.document.write('</body></html>');




        a.document.close();


        setTimeout(function () { a.print(); }, 500);
        a.onfocus = function () { setTimeout(function () { a.close(); }, 500); }
    }

    const dateFormat = 'DD-MM-YYYY';
    const dateChange = (date, dateString) => {
        if (date === null) {
            dispatch(appServices.PatientScreeningList(serviceTObj))
            // props.getServiceTemplate(pageSize, pageNumber);
        }
        else {

            const date1= convertDateFormat(dateString[0])
            const date2= convertDateFormat(dateString[1])
            // var str = dateString.toString();

            // str = str.split(",");

            // props.searchLetters(JSON.stringify(date[0]).replace(/['"]+/g, ''), JSON.stringify(date[1]).replace(/['"]+/g, ''))
            // alert(getformatedDate(str[0]) + " 00:00:00" + ",," + getformatedDate(str[1]) + " 23:59:59")
            //
            const tempSearch={
                PatientID: Profile[0].resource.id,
                StartDate: getformatedDate(date1) + " 00:00:00" , 
                EndDate : getformatedDate(date2) + " 23:59:59"
              }
              dispatch(appServices.PatientScreeningList(tempSearch))
            // props.searchLetters(getformatedDate(str[0]) + " 00:00:00", getformatedDate(str[1]) + " 23:59:59")

        }

    }
    return (
        <div>
            {/* <Header />
            <div id="myphonemenu" className="page-body">
                <Sidebar /> */}
                <div className="page-content-wrapper">
                    <div className="page-content-wrapper-inner">
                        <div className="viewport-header">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb has-arrow">
                                    <li className="breadcrumb-item">
                                        <a href="#">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Service Template</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="content-viewport">
                          
                            <div className="row">
                                <div className="col-12">
                                    <div className="grid">
                                        <div className="grid-body">
                                            <h2 className="grid-title">Service Template</h2>
                                            <div className="item-wrapper">
                                                {/* <div className="row mb-2">
                                                    <div className="col-md-8 mx-auto">
                                                        <div className="alert alert-warning" role="alert">
                                                            <h6 className="alert-heading">Please Note:</h6> */}

                                                {/* {
                                                    typeof Profile !== "undefined" && Profile.length ? (
                                                        // <p>{Profile[0].resource.extension[9].hasOwnProperty('valueString') ? Profile[0].resource.extension[9].valueString :"N/A" }</p>
                                                        Profile[0].resource.extension.map((item, index) => {
                                                            return (
                                                                item.url == "LetterDisclaimer" &&
                                                                <div className="row mb-2">

                                                                    <div className="col-md-8 mx-auto">
                                                                        <div className="alert alert-warning" role="alert">
                                                                            <h6 className="alert-heading">Please Note:</h6>

                                                                            <p>{item.valueString ? item.valueString : "N/A"}</p>
                                                                            {isFetching && <ActivityIndicator color='blue' size='small' />}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )
                                                        })
                                                    ) : null

                                                } */}
                                                {/* {Profile.map((person, i) => {
                                                                    <p>{person.resource.extension[8] !== undefined
                                                                        ? person.resource.extension[8].valueString
                                                                        : 'NO Data Found'}</p>
                                                                })} */}
                                                {/* <p>   {!isFetching && typeof (Profile[0].resource.extension[8].valueString) !== 'undefined' ? Profile[0].resource.extension[8].valueString : null}</p> */}
                                                {/* <p>{state.immuneMg}</p> */}
                                                {/* <p>Please be aware that the vaccination information displayed on this screen relates only to vaccines that were scheduled and/or administered by your treatment centre. Any vaccines administered outside of your treatment centre will not be recorded here</p> */}
                                                {/* </div>
                                                    </div>
                                                </div> */}

                                                {/* <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 10, paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}>
                                                    <Text>Select Date to Search </Text>
                                                    <RangePicker format={dateFormat} onChange={dateChange} />
                                                </View> */}
                                                <div className="drive-wrapper drive-grid-view">
                                                    <div className="grid-items-wrapper">
                                                        {
                                                            isServiceTemplate && <View style={{ textAlign: 'center', marginBottom: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
                                                        }
                                                        {
                                                            ServiceTemplate && ServiceTemplate.length ? (
                                                                ServiceTemplate.map((item) => {
                                                                    return (
                                                                        <ServiceHandler
                                                                            letterDate={GetAppointmentDate(item.resource.extension[10].valueString) + ' ' + GetMonthName(item.resource.extension[10].valueString) + ' ' + GetYear(item.resource.extension[10].valueString)}
                                                                            letterDetail={item.resource.extension[9].valueString}
                                                                            ScreaningID={item.resource.extension[1].valueString}
                                                                            setscreeningId={setscreeningId}
                                                                            screeningId= {screeningId}

                                                                        />
                                                                    )
                                                                })
                                                            ) : !isServiceTemplate && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                                                                <Text style={{ marginTop: 10, }}>No Records Found</Text>
                                                            </View>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Modal
                title="Service Template"
                centered
                open={visible}
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
                // afterClose={() => document.getElementById("showPDFLetters").innerHTML = ""}
                style={{ top: 10, bottom: 90, }}
                width={1500}
                footer={[
                    <Button key="back" onClick={() =>{
                        dispatch(appServices.gettingGetScreeningTemplateHTMLClear())
                     setVisible(false)}}>
                        Close
                    </Button>,
                    <Button key="submit" type="primary" onClick={() => handlePrint()}>
                        Print
                    </Button>
                ]}
            >
                <div style={{ height: '100%', width: '100%' }}>
                    <div ref={componentRef} style={{ padding: 2, }} className="PDF" id="showPDFLetters">
                        {/* <OuterHtml commingHtml={htmlLetter} /> */}
                        <div className="watermark">
                      {  isLoadingPdf ? <Spin/> :  <Iframe printRef={componentRef} content={htmlLetter} />}
                        </div>

                    </div>
                </div>

            </Modal>


                    </div>

                    <footer className="footer">

                    </footer>
                </div>

            {/* </div> */}

        </div>
    )
}


// function mapStateToProps(state) {
//     return {
//         ServiceTemplate: state.ServiceTemplate,
//         Profile: state.Profile,
//     }
// }

// function mapDispatchToProps(disptach) {
//     return {
//         // getProfile: () => disptach(fetchProfileFromApi()),
//         // getServiceTemplate: (pageSize, pageNumber) => disptach(fetchServiceTemplateApi(pageSize, pageNumber)),
//         searchLetters: (fromDate, toDate) => disptach(searchServiceTemplateFromApi(fromDate, toDate)),
//     }
// }
// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ServiceTemplate)
export default  ServiceTemplate




